import dayjs from 'dayjs'

export default {
  DEFAULT_DATE_PICKER_RANGE: {
    TODAY: '00',
    YESTERDAY: '01',
    THIS_MONTH: '02',
    LAST_MONTH: '03',
    LAST_WEEK: '04',
    ONE_QUARTER_BEFORE: '05',
    AFFILIATE_REPORT_KICKOFF_DATE: '20',
    AFFILIATE_REPORT_KICKOFF_DATE_RANGE: {
      START: dayjs('20200101', 'YYYY/MM/DD'),
      END: dayjs()
        .endOf('year')
        .endOf('day')
        .toDate()
    },
    CLICKS_REPORT_DATE: '21',
    CLICKS_REPORT_DATE_RANGE: {
      START: dayjs()
        .subtract(1, 'year')
        .startOf('month')
        .toDate(),
      END: dayjs()
        .endOf('year')
        .endOf('day')
        .toDate()
    },
    CVR_REPORT_DATE: '22',
    CVR_REPORT_DATE_RANGE: {
      START: dayjs('20211001', 'YYYY/MM/DD'),
      END: dayjs()
        .subtract(1, 'month')
        .endOf('day')
        .toDate()
    },
    AFFILIATE_REPORT_SETTLE_DATE: '22',
    AFFILIATE_REPORT_SETTLE_DATE_RANGE: {
      START: dayjs('20160101', 'YYYY/MM/DD'),
      END: dayjs()
        .endOf('year')
        .endOf('day')
        .toDate()
    },
    AFFILIATE_INVOICE_DATE_START: dayjs('20230304', 'YYYY-MM-DD'),
    COMMISSION_SETTING_DATE_RANGE: {
      START: dayjs().format('YYYY/MM/DD 00:00:00'),
      END: dayjs().add('Y', 1).subtract(1, 'days')
        .toDate()
    }
  }
}
